import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        width: fit-content;
        display: flex;
        gap: 16px;
    `,
    "PageButtonDiv": styled.div`
        display: flex;
        gap: 16px;
    `,
    "PageButton": styled.button`

        ${({ theme, $active }) => $active
            ? theme.font["medium-semibold"]
            : theme.font["medium-light"]
        }

        color: ${({ theme, $active }) => $active
            ? theme.color["black"]
            : theme.color["grey4"]
        };
    `
}